module.exports = __webpack_public_path__ + "static/img/top1.b9d0d90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top1.jpg
// module id = Z3dV
// module chunks = 0